import React from 'react';
import { NavMenu } from '../navMenu/NavMenu';
import './managementDashboard.css'

export function ManagementDashboard() {
    return (
        <div className="management-dashboard">
            <div className="container">
                <NavMenu />
                <div className="buttons row">
                    <div className="col-md-3 col-6">
                      <a href="/">
                          <button className="dashboard-btn illustration-btn">
                            <span>Illustration</span>
                          </button>
                      </a>
                    </div>
                    <div className="col-md-3 col-6">
                        <a href="/">
                         <button className="dashboard-btn about-btn">
                           <span>About</span>
                         </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}  